import React from "react";
import { Modal, Table } from "semantic-ui-react";

const Schema = ({ handleClose, show, properties }) => {
  return (
    <Modal open={show} onClose={handleClose}>
      <Modal.Header className="bg-primary"><i class="fa fa-gears"></i> Variables esquema</Modal.Header>
      <Modal.Content>
        <table class="table table-bordered" >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Nombre</Table.HeaderCell>
              <Table.HeaderCell>Tipo</Table.HeaderCell>
              <Table.HeaderCell>Longitud</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {Object.keys(properties).map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell>{item}</Table.Cell>
                <Table.Cell>{properties[item].type}</Table.Cell>
                <Table.Cell>{index}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </table>
      </Modal.Content>
      <Modal.Actions>
        <button className="btn btn-primary" onClick={handleClose}>
          Salir
        </button>
      </Modal.Actions>
    </Modal>
  );
};

Schema.defaultProps = {
  properties: {}
};

export default Schema;
